import { Loader2, RefreshCw } from "lucide-react";

/** The box it sits in: the rose fault line, or the amber role note (AccessDenied). */
const TONE = {
  fault: "border-rose-500/40 text-rose-700 hover:bg-rose-500/10 dark:text-rose-300",
  note: "border-amber-500/50 text-amber-800 hover:bg-amber-500/10 dark:text-amber-200",
} as const;

/**
 * The Retry on a failed read: ReadFailed's line and, given `onRetry`,
 * QueryErrorBanner's (#5078).
 *
 * aria-disabled, not disabled, while it reads again: a disabled button leaves
 * the focus order, and Chromium and WebKit then drop the keyboard focus to the
 * page body, so a keyboard user who pressed Retry was sent back to the top
 * (#2545). The click is ignored while it reads, as `disabled` did.
 */
export function RetryButton({
  onRetry,
  retrying = false,
  label,
  tone = "fault",
}: {
  onRetry: () => void;
  retrying?: boolean;
  /** The accessible name, when "Retry" alone would not say what is read again. */
  label?: string;
  tone?: keyof typeof TONE;
}) {
  return (
    <button
      type="button"
      onClick={() => {
        if (!retrying) onRetry();
      }}
      aria-label={label}
      aria-disabled={retrying || undefined}
      className={`inline-flex items-center gap-1.5 rounded-md border bg-background px-2.5 py-1 text-xs font-medium aria-disabled:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${TONE[tone]}`}
    >
      {retrying ? <Loader2 className="h-3 w-3 animate-spin" /> : <RefreshCw className="h-3 w-3" />}
      Retry
    </button>
  );
}
